export const home = {
  // Navbar
  navbar: {
    home: '首页',
    products: '产品',
    cases: '案例',
    about: '关于',
    contact: '联系',
    language: {
      zh: '中文',
      en: 'English'
    }
  },
  
  // Hero
  hero: {
    slides: [
      {
        title: '创新科技解决方案',
        description: '为企业提供前沿技术支持和数字化转型方案'
      },
      {
        title: '智能制造管理平台',
        description: '融合IT/OT/AI技术的自主可控系统平台'
      },
      {
        title: '卓越运营管理系统',
        description: '实现企业管理层与一线员工层无边界的高效沟通协作'
      }
    ]
  },
  
  // Solutions
  solutions: {
    title: '解决方案',
    subtitle: '为用户提供可信赖的智能制造解决方案',
    viewDetails: '查看详情',
    close: '关闭',
    productIntro: '产品介绍',
    coreFeatures: '核心功能',
    items: [
      {
        title: 'OPEX平台',
        subtitle: '支持系统:Android、IOS',
        description: '卓越运营管理',
        detail: '融合新一代IT/OT/AI技术的自主可控系统平台',
        fullDescription: 'OPEX平台是一个融合新一代IT/OT/AI技术的自主可控系统平台,专注于卓越运营管理。通过智能化的数据分析和流程优化,帮助企业实现运营效率的全面提升。',
        features: [
          '智能数据分析与可视化',
          '实时运营监控与预警',
          '流程自动化与优化',
          '跨平台移动端支持',
          '自主可控的安全架构'
        ]
      },
      {
        title: '现场安全管家',
        subtitle: '支持系统:Android、IOS',
        description: '实现企业管理层与一线',
        detail: '员工层无边界的高效沟通协作',
        fullDescription: '现场安全管家致力于实现企业管理层与一线员工层无边界的高效沟通协作,通过移动化、智能化的安全管理工具,全面提升现场安全管理水平。',
        features: [
          '实时安全隐患上报',
          '智能巡检与任务分配',
          '多级审批流程管理',
          '安全培训与考核',
          '数据统计与分析报表'
        ]
      },
      {
        title: '轻量化生产MES',
        subtitle: '支持系统:Android、IOS',
        description: '优化架构设计,实现快速部署',
        detail: '',
        fullDescription: '轻量化生产MES系统采用优化的架构设计,实现快速部署和灵活配置。帮助制造企业快速建立生产执行管理体系,提升生产效率和产品质量。',
        features: [
          '快速部署与配置',
          '生产计划与排程',
          '实时生产监控',
          '质量管理与追溯',
          '设备管理与维护'
        ]
      },
      {
        title: '轻量化仓储WMS',
        subtitle: '支持系统:Android、IOS',
        description: '降低物料异常损耗',
        detail: '降低工艺变化带来的呆滞料损耗',
        fullDescription: '轻量化仓储WMS系统专注于降低物料异常损耗,通过智能化的库存管理和预警机制,有效降低工艺变化带来的呆滞料损耗,提升仓储管理效率。',
        features: [
          '智能库存管理',
          '物料追溯与预警',
          '入库出库自动化',
          '呆滞料分析与处理',
          '移动端实时操作'
        ]
      }
    ]
  },
  
  // Service Process
  serviceProcess: {
    title: '服务流程',
    subtitle: '以客户需求为中心 以高效服务创品牌',
    steps: [
      {
        title: '需求沟通',
        description: '倾听客户需求,了解用户使用环境和操作流程'
      },
      {
        title: '签订合同',
        description: '依据客户需求,进行商务洽谈与合同签订'
      },
      {
        title: '交互设计',
        description: '头脑风暴交互情景模拟,原型设计'
      },
      {
        title: '方案确认',
        description: '依据业务需求与原型设计确认开发方案'
      },
      {
        title: '技术开发',
        description: '移动应用数据对接与开发'
      },
      {
        title: '测试反馈',
        description: '修改调整,规范完善'
      },
      {
        title: '跟进服务',
        description: '后续维护,持续跟进'
      }
    ]
  },
  
  // Case Studies
  caseStudies: {
    title: '客户案例',
    subtitle: '服务众多知名企业,助力数字化转型升级',
    projectOverview: '项目概述',
    coreFeatures: '核心功能',
    implementationResults: '实施效果',
    close: '关闭',
    cases: [
      {
        title: '尤欧现场安全管家',
        category: '安全管理系统',
        description: '为尤欧集团打造的现场安全管理系统,实现了安全隐患实时监控、风险预警和应急响应的全流程数字化管理。',
        highlights: ['实时监控', '风险预警', '应急响应', '数据分析'],
        results: '安全事故率降低85%,隐患处理效率提升300%'
      },
      {
        title: '奥克斯QMS',
        category: '质量管理系统',
        description: '为奥克斯集团开发的全面质量管理系统,涵盖质量计划、质量控制、质量保证和质量改进全过程。',
        highlights: ['质量追溯', '不良品管理', '供应商评估', '持续改进'],
        results: '产品合格率提升至99.5%,客户投诉减少70%'
      },
      {
        title: '双星轮胎MES',
        category: '制造执行系统',
        description: '为双星轮胎打造的智能制造执行系统,实现生产过程的实时监控、数据采集和智能调度。',
        highlights: ['生产调度', '设备联网', '质量追溯', '能耗管理'],
        results: '生产效率提升40%,能耗降低25%'
      },
      {
        title: '中国一汽WMS',
        category: '仓储管理系统',
        description: '为中国一汽开发的智能仓储管理系统,实现了入库、出库、库存管理的全流程自动化和智能化。',
        highlights: ['智能调度', '库位优化', '自动盘点', '数据可视化'],
        results: '仓储效率提升60%,库存准确率达99.8%'
      },
      {
        title: '苏州菲码MES',
        category: '制造执行系统',
        description: '为苏州菲码定制的MES系统,实现了从订单到交付的全流程数字化管理和智能化控制。',
        highlights: ['订单管理', '生产排程', '工艺管理', '设备监控'],
        results: '交付准时率提升至98%,生产周期缩短35%'
      },
      {
        title: '北元电气SRM',
        category: '供应商关系管理',
        description: '为北元电气构建的供应商关系管理平台,实现供应商全生命周期管理和协同。',
        highlights: ['供应商评估', '采购协同', '质量管控', '绩效分析'],
        results: '采购成本降低18%,供应链响应速度提升50%'
      }
    ]
  },
  
  // Partners
  partners: {
    title: '合作伙伴',
    strategicPartner: '战略合作伙伴',
    companyIntro: '企业简介',
    cooperation: '合作内容',
    close: '关闭',
    list: [
      {
        name: 'VanCut',
        description: 'VanCut是一家专注于智能制造解决方案的领先企业,致力于为制造业提供高效的生产管理系统。',
        cooperation: '与AiMS合作开发智能生产管理系统,实现生产流程的数字化转型。'
      },
      {
        name: 'Phoenix Contact',
        description: '菲尼克斯电气是全球领先的电气连接、电子接口技术和工业自动化领域的市场领导者。',
        cooperation: '在工业自动化和智能制造领域展开深度合作,共同推进工业4.0解决方案。'
      },
      {
        name: 'CEPD',
        description: 'CEPD专注于企业数字化转型,提供全方位的信息化解决方案和技术支持。',
        cooperation: '携手打造企业级数字化平台,助力企业实现智能化管理。'
      },
      {
        name: 'Beyone',
        description: 'Beyone是一家创新型科技公司,专注于为企业提供智能化的业务管理解决方案。',
        cooperation: '共同研发智能业务管理系统,提升企业运营效率。'
      },
      {
        name: '五金机电行协',
        description: '五金机电行业协会致力于推动五金机电行业的发展,为会员企业提供技术交流、市场信息和行业标准制定等服务。',
        cooperation: '在五金机电行业数字化转型领域建立战略合作关系,共同推动行业智能化升级。'
      },
      {
        name: 'KANGDA',
        description: '康达集团是一家综合性企业集团,业务涵盖制造、科技、服务等多个领域。',
        cooperation: '在智能制造和企业信息化方面开展全面合作。'
      },
      {
        name: 'CETC',
        description: '中国电子科技集团是国内领先的电子信息技术企业,在信息安全和智能系统领域具有深厚实力。',
        cooperation: '在企业信息化和智能系统集成方面建立长期战略合作伙伴关系。'
      }
    ]
  },
  
  // About
  about: {
    title: '关于安码士',
    subtitle: '专注企业数字化解决方案,助力企业数字化转型',
    companyIntro: '公司简介',
    vision: '愿景',
    mission: '使命',
    coreValues: '核心价值观',
    introduction: '安码士(北京)科技有限公司是一家专注于企业数字化解决方案的高新技术企业。我们致力于为制造业、物流业等行业提供专业的软件开发和系统集成服务。',
    visionText: '成为中国领先的企业数字化解决方案提供商,助力企业数字化转型。',
    missionText: '通过创新的技术和专业的服务,帮助企业提升管理效率,降低运营成本,实现可持续发展。',
    stats: [
      { number: '20+', label: '年行业经验' },
      { number: '200+', label: '服务企业' },
      { number: '50+', label: '专业团队' },
      { number: '98%', label: '客户满意度' }
    ],
    values: [
      { title: '创新', description: '持续创新,引领技术发展' },
      { title: '专业', description: '专业团队,精益求精' },
      { title: '服务', description: '客户至上,用心服务' },
      { title: '卓越', description: '追求卓越,成就客户' }
    ]
  },
  
  // Footer
  footer: {
    address: '地址',
    phone: '电话',
    fax: '传真',
    email: '邮箱',
    addressContent: ['北京总部:北京市海淀区知春路盈都大厦C座', '辽宁分公司:辽宁省鞍山市立山区宏昊城色'],
    phoneContent: ['Tel: +86-10-52471922'],
    faxContent: ['Fax: +86-10-52471929'],
    emailContent: ['Email: yourbestanswer@163.com'],
    copyright: 'AiMS ©2012-2025 京ICP备12014991号-1 京公安网安备11010802012650',
    backToTop: '返回顶部'
  }
};
